// Olion Product Catalog — 58 products with full FR/EN/AR translations
// Generated automatically from Excel. Image URLs filled in as photos are uploaded.

// Mapping: filename (as in Excel column K) -> uploaded image URL.
// Add new entries here when new images arrive.
export const imageMap = {
  // Air Fresh — Batch 1 (uploaded 24 May 2026)
  "AIR FRAICHE AOUD 250 ML": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/3sv1bycp_AIR%20FRAICHE%20AOUD%20250%20ML.png",
  "AIR FRAICHE AOUD 500 ML": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/m15ctczl_AIR%20FRAICHE%20AOUD%20500%20ML.png",
  "AIR FRAICHE FLEURE DE SHINE 250ML": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/0y8m45h9_AIR%20FRAICHE%20FLEURE%20DE%20SHINE%20250ML.png",
  "AIR FRAICHE FLEUR DE SHINE 500 ML": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/rlawpkbh_AIR%20FRAICHE%20FLEURE%20DE%20SHINE%20500ML.png",
  "AIR FRAICHE LAVANDE 250 ML": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/eloftal6_AIR%20FRAICHE%20LAVANDE%20250%20ML.png",

  // Air Fresh — Batch 2 (uploaded 24 May 2026)
  "AIR FRAICHE LAVANDE 500 ML": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/y6zpqi5l_AIR%20FRAICHE%20LAVANDE%20500%20ML.png",
  "AIR FRAICHE OCEAN 250ML": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/tyoh8mlr_AIR%20FRAICHE%20OCEAN%20250ML.png",
  "AIR FRAICHE OCEAN 500 ML": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/1sk20q5t_AIR%20FRAICHE%20OCEAN%20500%20ML.png",
  "AIR-FRESH FRUIT 250 ML": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/yi0dka83_AIR-FRESH%20FRUIT%20250%20ML.png",
  "AIR FRAICHE FRUIT 500 ML": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/onamh2bw_AIR-FRESH%20FRUIT%20500%20ML.png",

  // Kitchen & Laundry — Batch 3 (uploaded 24 May 2026)
  "ANTI-GRAS 1L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/wu3f5o0d_ANTI-GRAS%201L.png",
  "ANTI-GRAS 5L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/har97br4_ANTI-GRAS%205L.png",
  "ANTI-TACHES 1L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/m4jx6kc5_ANTI-TACHES%201L.png",
  "ANTI-TACHES 5L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/mzv2rbdi_ANTI-TACHES%205L.png",
  "APRES SHAMPOING NOIX DE COCO 5 L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/jhey2snc_APRES%20SHAMPOING%20NOIX%20DE%20COCO%205%20L.png",

  // Laundry softeners — Batch 4 (uploaded 24 May 2026)
  "ASSOUPLISSANT FLEUR DE LYS 3L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/xwawo0gv_ASSOUPLISSANT%20FLEUR%20DE%20LYS%203L.jpg",
  "ASSOUPLISSANT LAVANDE 1L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/i1597nuq_ASSOUPLISSANT%20LAVANDE%201L.jpg",
  "ASSOUPLISSANT LAVANDE 3L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/0r6w8dlk_ASSOUPLISSANT%20LAVANDE%203L.jpg",
  "ASSOUPLISSANT FLEUR DE LYS 1L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/7ddbuv9s_ASSOUPLISSANT%20FLEUR%20DE%20LYS%201L.png",

  // Javel — temporary photo (shared between 1L retail and 5L industrial until separate photos provided)
  "JAVEL 1L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/0sq01jsu_JAVEL%201L.png",
  "JAVEL 5L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/xu76jfs0_JAVEL%205L.png",

  // Deodorants — Batch 5 (uploaded 24 May 2026)
  "DESODORISSANT FAWAH 1L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/00tdc4st_DESODORISSANT%20FAWAH%201L.png",
  "DESODORISSANT FAWAH 5L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/pqx8xl53_DESODORISSANT%20FAWAH%205L.png",
  "DESODORISSANT FLEUR 1L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/vxqcc72y_DESODORISSANT%20FLEUR%201L.png",
  "DESODORISSANT FLEUR 5L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/l36l3fcs_DESODORISSANT%20FLEUR%205L.png",
  "DESODORISSANT OCEAN 1L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/b9om78ul_DESODORISSANT%20OCEAN%201L.png",

  // Lot 6 (uploaded 24 May 2026) — Deodorant Ocean 5L + Gel Douche + Gel Machine Auto
  "DESODORISSANT OCEAN 5L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/3s0x1u6m_DESODORISSANT%20OCEAN%205L.png",
  "GEL DOUCH OCEAN 5L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/2v2asni7_GEL%20DOUCH%20OCEAN%205L.png",
  "GEL DOUCHE LA ROSE 5L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/ag9tj6rc_GEL%20DOUCHE%20LA%20ROSE%205L.png",
  "GEL_MACHINE_AUTO_OCEAN_3L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/vchynem3_GEL_MACHINE_AUTO_OCEAN_3L-removebg-preview.png",
  "GEL_MACHINE_AUTO_POWER_GEL_3L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/p46u1u2i_GEL_MACHINE_AUTO_POWER_GEL_3L-removebg-preview.png",

  // Lot 7 — Gel Machine Pro 10L
  "GEL MACHINE LAVANDE 10L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/h9g8s5ot_GEL%20MACHINE%20LAVANDE%2010L.png",
  "GEL MACHINE OCEAN 10L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/gqv3x9pt_GEL%20MACHINE%20OCEAN%2010L.png",
  "GEL MACHINE SAVON DE MARSEILLE 10L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/3nli7fej_GEL%20MACHINE%20SAVON%20DE%20MARSEILLE%2010L.png",

  // Lot 8 — Gel Machine Auto Marseille + Hand soaps
  "GEL_MACHINE_AUTO_SAVON_DE_MARSEILLE_3L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/33nnc8ww_GEL_MACHINE_AUTO_SAVON_DE_MARSEILLE_3L-removebg-preview.png",
  "LAVE MAIN BLANC 500 ML": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/6a43ssrg_LAVE%20MAIN%20BLANC%20500%20ML.png",
  "LAVE MAIN FRUIT ROUGE 1 L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/kuy5skfi_LAVE%20MAIN%20FRUIT%20ROUGE%201L.png",
  "LAVE MAIN FRUIT ROUGE 5 L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/kdt80dqk_LAVE%20MAIN%20FRUIT%20ROUGE%205L.png",

  // Lot 9 — Hand soaps Fruite + Lavande
  "LAVE MAIN FRUITE 500 ML": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/zp5o9zy9_LAVE%20MAIN%20FRUITE%20500%20ML.png",
  "LAVE MAIN LAVANDE 5 L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/ejhmf28a_LAVE%20MAIN%20LAVANDE%205%20L.png",
  "LAVE MAIN LAVANDE 1000 ML": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/w9jkfknc_LAVE%20MAIN%20LAVANDE%201000%20ML.png",
  "LAVE MAIN LAVENDE 500 ML": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/pd1v7oi7_LAVE%20MAIN%20LAVENDE%20500%20ML.png",

  // Lot 10 — Vanille hand soaps + Dishwashing
  "LAVE MAIN VANILLE 5 L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/4f96g44q_LAVE%20MAIN%20VANILLE%205%20L.png",
  "LAVE MAIN VANILLE 1 L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/rxwfvga3_LAVE%20MAIN%20VANILLE%201000%20ML.png",
  "LAVE VAISSELLES CITRON 1L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/uqeq2cki_LAVE%20VAISSELLES%20CITRON%201L.png",
  "LAVE VAISSELLES CITRON 5L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/r2muyqjy_LAVE%20VAISSELLES%20CITRON%205L.png",
  "LAVE VAISSELLES POMME 1L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/nges0cn9_LAVE%20VAISSELLES%20POMME%201L.png",

  // Lot 11 — Final cleaning products + insecticide + power oxygen
  "LAVE VAISSELLES POMME 5L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/5i9ct3ds_LAVE%20VAISSELLES%20POMME%205L.png",
  "LAVE VITRE 500 ML": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/h4zm0338_LAVE%20VITRE%20500%20ML.png",
  "OLION TOX 5L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/ybmhc2u4_OLION%20TOX%205L.png",
  "PARFUM DE LINGE 500 ML": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/u5wi722l_PARFUM%20DE%20LINGE%20500%20ML.png",
  "POWER OXYGEN 1 L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/yv2isgcq_POWER%20OXYGEN%201%20L.png",

  // Lot 12 — FINAL BATCH (24 May 2026) — Catalogue complet 100%
  "POWER OXYGEN 3 L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/4l4tf3ch_POWER%20OXYGEN%203%20L.png",
  "SHAMPOING MIEL ARGANT 5L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/qe1xllwc_SHAMPOING%20MIEL%20ARGANT%205L.png",
  "SHAMPOING POMME-MENTHE 5L": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/5u40vcxu_SHAMPOING%20POMME-MENTHE%205L.png",
  "WC GEL 750ML": "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/bygnulhd_WC%20GEL%20750%20ML.png",
};

// Default placeholder for products without images yet
const PLACEHOLDER_IMAGE = "https://customer-assets.emergentagent.com/job_a5a52270-1821-48dd-806e-4fc805561245/artifacts/2sq8ewln_LAVE%20VAISSELLES%20CITRON%201L.png";

const rawProducts = [
  {
    id: "anti-gras-1-l",
    nameFr: "Anti-Gras",
    nameEn: "Anti-Grease",
    nameAr: "مزيل الدهون",
    category: "retail",
    subCategory: "kitchen",
    size: "1L",
    imageFilename: "ANTI-GRAS 1L",
    descriptionFr: "Dégraissant cuisine professionnel pour graisses cuites et incrustations carbonisées. À utiliser sur plaques de cuisson, hottes, fours, friteuses et plans de travail inox — il dissout en quelques secondes ce que d'autres ne font qu'effleurer. Conditionnement : 1L.",
    descriptionEn: "Professional kitchen degreaser for baked grease and charred residue. Use on cooktops, hoods, ovens, fryers and stainless work surfaces — dissolves in seconds what others barely touch. Packaging: 1L.",
    descriptionAr: "مزيل دهون احترافي للمطابخ، للدهون المتيبسة والرواسب المتفحمة. للاستعمال على مواقد الطهي، الشفاطات، الأفران، المقالي وأسطح العمل من الفولاذ — يذيب في ثوان ما لا تستطيع المنظفات الأخرى لمسه. العبوة: 1L.",
    featuresFr: ["Dégraissant ultra-puissant", "Dissout graisses incrustées", "Multi-surfaces cuisine"],
    featuresEn: ["Ultra-powerful Degreaser", "Dissolves baked grease", "Multi-surface kitchen"],
    featuresAr: ["مزيل دهون فائق القوة", "يذيب الدهون المتراكمة", "متعدد الأسطح للمطبخ"],
  },
  {
    id: "anti-gras-5-l",
    nameFr: "Anti-Gras",
    nameEn: "Anti-Grease",
    nameAr: "مزيل الدهون",
    category: "industrial",
    subCategory: "kitchen",
    size: "5L",
    imageFilename: "ANTI-GRAS 5L",
    descriptionFr: "Dégraissant cuisine professionnel pour graisses cuites et incrustations carbonisées. À utiliser sur plaques de cuisson, hottes, fours, friteuses et plans de travail inox — il dissout en quelques secondes ce que d'autres ne font qu'effleurer. Conditionnement : 5L.",
    descriptionEn: "Professional kitchen degreaser for baked grease and charred residue. Use on cooktops, hoods, ovens, fryers and stainless work surfaces — dissolves in seconds what others barely touch. Packaging: 5L.",
    descriptionAr: "مزيل دهون احترافي للمطابخ، للدهون المتيبسة والرواسب المتفحمة. للاستعمال على مواقد الطهي، الشفاطات، الأفران، المقالي وأسطح العمل من الفولاذ — يذيب في ثوان ما لا تستطيع المنظفات الأخرى لمسه. العبوة: 5L.",
    featuresFr: ["Dégraissant ultra-puissant", "Dissout graisses incrustées", "Multi-surfaces cuisine"],
    featuresEn: ["Ultra-powerful Degreaser", "Dissolves baked grease", "Multi-surface kitchen"],
    featuresAr: ["مزيل دهون فائق القوة", "يذيب الدهون المتراكمة", "متعدد الأسطح للمطبخ"],
  },
  {
    id: "lave-vaisselles-citron-1-l",
    nameFr: "Lave Vaisselle Citron",
    nameEn: "Lemon Dish Soap",
    nameAr: "سائل جلي بالليمون",
    category: "retail",
    subCategory: "kitchen",
    size: "1L",
    imageFilename: "LAVE VAISSELLES CITRON 1L",
    descriptionFr: "Liquide vaisselle dégraissant au Citron pétillant, qui élimine les graisses cuites tout en respectant la peau de vos mains. Sa mousse dense et durable atteint l'envers des plats pour une vaisselle éclatante, sans traces ni voile. Conditionnement : 1L.",
    descriptionEn: "Sparkling Lemon dishwashing liquid that removes baked-on grease while caring for your hands. Its dense, long-lasting foam reaches behind dishes for sparkling crockery, with no streaks or film. Packaging: 1L.",
    descriptionAr: "سائل جلي بالليمون المنعش، يزيل الدهون المتيبسة مع العناية بيديك. رغوته الكثيفة الدائمة تصل لخلفية الأواني للحصول على أطباق لامعة دون آثار أو طبقات. العبوة: 1L.",
    featuresFr: ["Parfum Citron pétillant", "Dégraissant ultra-rapide", "Vaisselle brillante sans traces"],
    featuresEn: ["Sparkling Lemon Scent", "Ultra-fast degreaser", "Streak-free shiny dishes"],
    featuresAr: ["عطر ليمون منعش", "مزيل دهون فائق السرعة", "أطباق لامعة بلا آثار"],
  },
  {
    id: "lave-vaisselles-citron-5-l",
    nameFr: "Lave Vaisselle Citron",
    nameEn: "Lemon Dish Soap",
    nameAr: "سائل جلي بالليمون",
    category: "industrial",
    subCategory: "kitchen",
    size: "5L",
    imageFilename: "LAVE VAISSELLES CITRON 5L",
    descriptionFr: "Liquide vaisselle dégraissant au Citron pétillant, qui élimine les graisses cuites tout en respectant la peau de vos mains. Sa mousse dense et durable atteint l'envers des plats pour une vaisselle éclatante, sans traces ni voile. Conditionnement : 5L.",
    descriptionEn: "Sparkling Lemon dishwashing liquid that removes baked-on grease while caring for your hands. Its dense, long-lasting foam reaches behind dishes for sparkling crockery, with no streaks or film. Packaging: 5L.",
    descriptionAr: "سائل جلي بالليمون المنعش، يزيل الدهون المتيبسة مع العناية بيديك. رغوته الكثيفة الدائمة تصل لخلفية الأواني للحصول على أطباق لامعة دون آثار أو طبقات. العبوة: 5L.",
    featuresFr: ["Parfum Citron pétillant", "Dégraissant ultra-rapide", "Vaisselle brillante sans traces"],
    featuresEn: ["Sparkling Lemon Scent", "Ultra-fast degreaser", "Streak-free shiny dishes"],
    featuresAr: ["عطر ليمون منعش", "مزيل دهون فائق السرعة", "أطباق لامعة بلا آثار"],
  },
  {
    id: "lave-vaisselles-pomme-1-l",
    nameFr: "Lave Vaisselle Pomme",
    nameEn: "Apple Dish Soap",
    nameAr: "سائل جلي بالتفاح",
    category: "retail",
    subCategory: "kitchen",
    size: "1L",
    imageFilename: "LAVE VAISSELLES POMME 1L",
    descriptionFr: "Liquide vaisselle parfumé à la Pomme verte fraîche, doux pour les mains et puissant sur la graisse. Formule pH équilibré, mousse onctueuse et rinçage rapide pour gagner du temps en cuisine au quotidien. Conditionnement : 1L.",
    descriptionEn: "Fresh Green Apple dishwashing liquid, gentle on hands and tough on grease. Balanced-pH formula, creamy foam and quick rinsing to save time in the kitchen every day. Packaging: 1L.",
    descriptionAr: "سائل جلي بعطر التفاح الأخضر الطازج، لطيف على اليدين وقوي ضد الدهون. تركيبة متوازنة الحموضة، رغوة كريمية وشطف سريع لتوفير الوقت في المطبخ يومياً. العبوة: 1L.",
    featuresFr: ["Parfum Pomme verte fraîche", "Mousse onctueuse abondante", "Doux pour les mains"],
    featuresEn: ["Fresh Green Apple Scent", "Rich abundant foam", "Gentle on hands"],
    featuresAr: ["عطر التفاح الأخضر الطازج", "رغوة كثيفة وفيرة", "لطيف على اليدين"],
  },
  {
    id: "lave-vaisselles-pomme-5-l",
    nameFr: "Lave Vaisselle Pomme",
    nameEn: "Apple Dish Soap",
    nameAr: "سائل جلي بالتفاح",
    category: "industrial",
    subCategory: "kitchen",
    size: "5L",
    imageFilename: "LAVE VAISSELLES POMME 5L",
    descriptionFr: "Liquide vaisselle parfumé à la Pomme verte fraîche, doux pour les mains et puissant sur la graisse. Formule pH équilibré, mousse onctueuse et rinçage rapide pour gagner du temps en cuisine au quotidien. Conditionnement : 5L.",
    descriptionEn: "Fresh Green Apple dishwashing liquid, gentle on hands and tough on grease. Balanced-pH formula, creamy foam and quick rinsing to save time in the kitchen every day. Packaging: 5L.",
    descriptionAr: "سائل جلي بعطر التفاح الأخضر الطازج، لطيف على اليدين وقوي ضد الدهون. تركيبة متوازنة الحموضة، رغوة كريمية وشطف سريع لتوفير الوقت في المطبخ يومياً. العبوة: 5L.",
    featuresFr: ["Parfum Pomme verte fraîche", "Mousse onctueuse abondante", "Doux pour les mains"],
    featuresEn: ["Fresh Green Apple Scent", "Rich abundant foam", "Gentle on hands"],
    featuresAr: ["عطر التفاح الأخضر الطازج", "رغوة كثيفة وفيرة", "لطيف على اليدين"],
  },
  {
    id: "anti-taches-1-l",
    nameFr: "Anti-Taches",
    nameEn: "Stain Remover",
    nameAr: "مزيل البقع",
    category: "retail",
    subCategory: "laundry",
    size: "1L",
    imageFilename: "ANTI-TACHES 1L",
    descriptionFr: "Détachant ciblé haute efficacité pour taches difficiles : graisse, sang, fruits, vin et encre. Sa formule pénétrante agit en quelques minutes sans abîmer les fibres ni les couleurs, en pré-traitement ou complément du cycle. Conditionnement : 1L.",
    descriptionEn: "Highly effective targeted stain remover for difficult stains: grease, blood, fruit, wine and ink. Its penetrating formula acts in minutes without damaging fibers or colors, as pre-treatment or cycle booster. Packaging: 1L.",
    descriptionAr: "مزيل بقع مستهدف عالي الفعالية للبقع الصعبة: دهون، دم، فواكه، نبيذ وحبر. تركيبته النافذة تعمل في دقائق دون إتلاف الألياف أو الألوان، كمعالجة أولية أو معزز للدورة. العبوة: 1L.",
    featuresFr: ["Détachant ciblé professionnel", "Préserve l'éclat des fibres", "Avant ou pendant lavage"],
    featuresEn: ["Professional Targeted Stain Remover", "Preserves fiber brightness", "Pre or during wash"],
    featuresAr: ["مزيل بقع احترافي مستهدف", "يحافظ على بريق الألياف", "قبل أو أثناء الغسيل"],
  },
  {
    id: "anti-taches-5-l",
    nameFr: "Anti-Taches",
    nameEn: "Stain Remover",
    nameAr: "مزيل البقع",
    category: "industrial",
    subCategory: "laundry",
    size: "5L",
    imageFilename: "ANTI-TACHES 5L",
    descriptionFr: "Détachant ciblé haute efficacité pour taches difficiles : graisse, sang, fruits, vin et encre. Sa formule pénétrante agit en quelques minutes sans abîmer les fibres ni les couleurs, en pré-traitement ou complément du cycle. Conditionnement : 5L.",
    descriptionEn: "Highly effective targeted stain remover for difficult stains: grease, blood, fruit, wine and ink. Its penetrating formula acts in minutes without damaging fibers or colors, as pre-treatment or cycle booster. Packaging: 5L.",
    descriptionAr: "مزيل بقع مستهدف عالي الفعالية للبقع الصعبة: دهون، دم، فواكه، نبيذ وحبر. تركيبته النافذة تعمل في دقائق دون إتلاف الألياف أو الألوان، كمعالجة أولية أو معزز للدورة. العبوة: 5L.",
    featuresFr: ["Détachant ciblé professionnel", "Préserve l'éclat des fibres", "Avant ou pendant lavage"],
    featuresEn: ["Professional Targeted Stain Remover", "Preserves fiber brightness", "Pre or during wash"],
    featuresAr: ["مزيل بقع احترافي مستهدف", "يحافظ على بريق الألياف", "قبل أو أثناء الغسيل"],
  },
  {
    id: "assouplissant-fleur-de-lys-3-l",
    nameFr: "Assouplissant Fleur de Lys",
    nameEn: "Lily Fabric Softener",
    nameAr: "ملطف الأقمشة زهرة الزنبق",
    category: "retail",
    subCategory: "laundry",
    size: "3L",
    imageFilename: "ASSOUPLISSANT FLEUR DE LYS 3L",
    descriptionFr: "Adoucissant textile aux notes raffinées de Fleur de Lys, conçu pour envelopper vos vêtements d'un parfum élégant et durable. Sa formule concentrée détend les fibres, neutralise l'électricité statique et facilite le repassage. Conditionnement : 3L.",
    descriptionEn: "Textile softener with refined Lily flower notes, designed to envelope your clothes in an elegant, long-lasting fragrance. Its concentrated formula relaxes fibers, neutralizes static and makes ironing easier. Packaging: 3L.",
    descriptionAr: "ملطف الأقمشة بنفحات زهرة الزنبق الراقية، مصمم ليغلف ملابسك بعطر أنيق ودائم. تركيبته المركزة تريح الألياف، تحيد الكهرباء الساكنة وتسهل الكي. العبوة: 3L.",
    featuresFr: ["Parfum Fleur de Lys Premium", "Anti-électricité statique", "Repassage facilité"],
    featuresEn: ["Premium Lily Fragrance", "Anti-static action", "Easier ironing"],
    featuresAr: ["عطر زنبق فاخر", "مضاد للكهرباء الساكنة", "كي أسهل"],
  },
  {
    id: "assouplissant-fleur-de-lys-1-l",
    nameFr: "Assouplissant Fleur de Lys",
    nameEn: "Lily Fabric Softener",
    nameAr: "ملطف الأقمشة زهرة الزنبق",
    category: "retail",
    subCategory: "laundry",
    size: "1L",
    imageFilename: "ASSOUPLISSANT FLEUR DE LYS 1L",
    descriptionFr: "Adoucissant textile aux notes raffinées de Fleur de Lys, conçu pour envelopper vos vêtements d'un parfum élégant et durable. Sa formule concentrée détend les fibres, neutralise l'électricité statique et facilite le repassage. Conditionnement : 1L.",
    descriptionEn: "Textile softener with refined Lily flower notes, designed to envelope your clothes in an elegant, long-lasting fragrance. Its concentrated formula relaxes fibers, neutralizes static and makes ironing easier. Packaging: 1L.",
    descriptionAr: "ملطف الأقمشة بنفحات زهرة الزنبق الراقية، مصمم ليغلف ملابسك بعطر أنيق ودائم. تركيبته المركزة تريح الألياف، تحيد الكهرباء الساكنة وتسهل الكي. العبوة: 1L.",
    featuresFr: ["Parfum Fleur de Lys Premium", "Anti-électricité statique", "Repassage facilité"],
    featuresEn: ["Premium Lily Fragrance", "Anti-static action", "Easier ironing"],
    featuresAr: ["عطر زنبق فاخر", "مضاد للكهرباء الساكنة", "كي أسهل"],
  },
  {
    id: "assouplissant-lavande-1-l",
    nameFr: "Assouplissant Lavande",
    nameEn: "Lavender Fabric Softener",
    nameAr: "ملطف الأقمشة لافندر",
    category: "retail",
    subCategory: "laundry",
    size: "1L",
    imageFilename: "ASSOUPLISSANT LAVANDE 1L",
    descriptionFr: "Adoucissant infusé à la Lavande de Provence, idéal pour un linge moelleux au parfum apaisant. Sa formule équilibrée préserve les couleurs, allonge la durée de vie des tissus et procure une fraîcheur enveloppante du dressing au lit. Conditionnement : 1L.",
    descriptionEn: "Softener infused with Provence Lavender, perfect for cosy laundry with a soothing scent. Its balanced formula preserves colors, extends fabric lifespan and delivers enveloping freshness from wardrobe to bed. Packaging: 1L.",
    descriptionAr: "ملطف منقوع بلافندر بروفانس، مثالي لغسيل ناعم بعطر مهدئ. تركيبته المتوازنة تحافظ على الألوان، تطيل عمر الأقمشة وتمنح نضارة محيطة من الخزانة إلى السرير. العبوة: 1L.",
    featuresFr: ["Parfum Lavande apaisant", "Fibres ultra-douces", "Fraîcheur longue durée"],
    featuresEn: ["Soothing Lavender Scent", "Ultra-soft fibers", "Long-lasting freshness"],
    featuresAr: ["عطر لافندر مهدئ", "ألياف فائقة النعومة", "نضارة طويلة الأمد"],
  },
  {
    id: "assouplissant-lavande-3-l",
    nameFr: "Assouplissant Lavande",
    nameEn: "Lavender Fabric Softener",
    nameAr: "ملطف الأقمشة لافندر",
    category: "retail",
    subCategory: "laundry",
    size: "3L",
    imageFilename: "ASSOUPLISSANT LAVANDE 3L",
    descriptionFr: "Adoucissant infusé à la Lavande de Provence, idéal pour un linge moelleux au parfum apaisant. Sa formule équilibrée préserve les couleurs, allonge la durée de vie des tissus et procure une fraîcheur enveloppante du dressing au lit. Conditionnement : 3L.",
    descriptionEn: "Softener infused with Provence Lavender, perfect for cosy laundry with a soothing scent. Its balanced formula preserves colors, extends fabric lifespan and delivers enveloping freshness from wardrobe to bed. Packaging: 3L.",
    descriptionAr: "ملطف منقوع بلافندر بروفانس، مثالي لغسيل ناعم بعطر مهدئ. تركيبته المتوازنة تحافظ على الألوان، تطيل عمر الأقمشة وتمنح نضارة محيطة من الخزانة إلى السرير. العبوة: 3L.",
    featuresFr: ["Parfum Lavande apaisant", "Fibres ultra-douces", "Fraîcheur longue durée"],
    featuresEn: ["Soothing Lavender Scent", "Ultra-soft fibers", "Long-lasting freshness"],
    featuresAr: ["عطر لافندر مهدئ", "ألياف فائقة النعومة", "نضارة طويلة الأمد"],
  },
  {
    id: "gel-machine-auto-ocean-3-l",
    nameFr: "Gel Machine Auto Océan",
    nameEn: "Auto Machine Gel Ocean",
    nameAr: "جل غسالة أوتوماتيك أوشن",
    category: "retail",
    subCategory: "laundry",
    size: "3L",
    imageFilename: "GEL_MACHINE_AUTO_OCEAN_3L",
    descriptionFr: "Lessive gel haute performance parfumée à la fraîcheur marine, formulée pour lave-linge automatique. Action anti-taches dès le premier cycle, respect des couleurs et dosage économique grâce à sa formule concentrée. Conditionnement : 3L.",
    descriptionEn: "High-performance gel detergent with marine freshness scent, formulated for automatic washing machines. Stain-fighting from the first cycle, color-safe and economical dosing thanks to its concentrated formula. Packaging: 3L.",
    descriptionAr: "منظف جل عالي الأداء معطر بنضارة بحرية، مصمم للغسالات الأوتوماتيكية. يزيل البقع من أول دورة، يحافظ على الألوان وجرعة اقتصادية بفضل تركيبته المركزة. العبوة: 3L.",
    featuresFr: ["Fraîcheur Marine intense", "Anti-taches dès le 1er cycle", "Compatible toutes machines"],
    featuresEn: ["Intense Marine Freshness", "Stain-fighting first cycle", "All machines compatible"],
    featuresAr: ["نضارة بحرية مكثفة", "إزالة البقع من أول دورة", "متوافق مع جميع الغسالات"],
  },
  {
    id: "gel-machine-auto-power-gel-3-l",
    nameFr: "Gel Machine Auto Power",
    nameEn: "Auto Machine Power Gel",
    nameAr: "جل غسالة أوتوماتيك باور",
    category: "retail",
    subCategory: "laundry",
    size: "3L",
    imageFilename: "GEL_MACHINE_AUTO_POWER_GEL_3L",
    descriptionFr: "Lessive gel ultra-concentrée pour linge très sale et taches incrustées. Sa formule renforcée en agents nettoyants pénètre profondément les fibres pour un blanc éclatant et des couleurs ravivées, cycle après cycle. Conditionnement : 3L.",
    descriptionEn: "Ultra-concentrated gel detergent for heavily soiled laundry and ingrained stains. Its boosted cleaning-agent formula penetrates deep into fibers for brilliant whites and revived colors, cycle after cycle. Packaging: 3L.",
    descriptionAr: "منظف جل فائق التركيز للملابس شديدة الاتساخ والبقع المتأصلة. تركيبته المعززة بعوامل تنظيف تخترق الألياف بعمق لإشراق الأبيض وإعادة حيوية الألوان دورة تلو الأخرى. العبوة: 3L.",
    featuresFr: ["Action nettoyante intensive", "Élimine les taches tenaces", "Concentré haute efficacité"],
    featuresEn: ["Intensive Cleaning Action", "Removes stubborn stains", "High-efficiency concentrate"],
    featuresAr: ["تنظيف مكثف قوي", "يزيل البقع العنيدة", "تركيز عالي الفعالية"],
  },
  {
    id: "gel-machine-auto-savon-de-marseille-3-l",
    nameFr: "Gel Machine Auto Savon de Marseille",
    nameEn: "Auto Machine Gel Marseille Soap",
    nameAr: "جل غسالة أوتوماتيك صابون مرسيليا",
    category: "retail",
    subCategory: "laundry",
    size: "3L",
    imageFilename: "GEL_MACHINE_AUTO_SAVON_DE_MARSEILLE_3L",
    descriptionFr: "Lessive gel inspirée de la tradition séculaire du Savon de Marseille, alliant pureté naturelle et efficacité moderne. Particulièrement indiquée pour les peaux sensibles, elle nettoie en douceur sans agresser les fibres ni la peau. Conditionnement : 3L.",
    descriptionEn: "Gel detergent inspired by the centuries-old tradition of Marseille Soap, combining natural purity with modern effectiveness. Especially suitable for sensitive skin, it cleans gently without aggressing fibers or skin. Packaging: 3L.",
    descriptionAr: "منظف جل مستوحى من تقليد صابون مرسيليا العريق، يجمع بين النقاء الطبيعي والفعالية الحديثة. مناسب بشكل خاص للبشرة الحساسة، ينظف بلطف دون إضرار بالألياف أو البشرة. العبوة: 3L.",
    featuresFr: ["Authentique Savon de Marseille", "Pureté traditionnelle", "Doux pour les fibres"],
    featuresEn: ["Authentic Marseille Soap", "Traditional purity", "Gentle on fibers"],
    featuresAr: ["صابون مرسيليا أصيل", "نقاء تقليدي", "لطيف على الأقمشة"],
  },
  {
    id: "gel-machine-lavande-10-l",
    nameFr: "Gel Machine Lavande",
    nameEn: "Machine Gel Lavender",
    nameAr: "جل غسالة لافندر",
    category: "industrial",
    subCategory: "laundry",
    size: "10L",
    imageFilename: "GEL MACHINE LAVANDE 10L",
    descriptionFr: "Solution professionnelle 10 L parfumée à la Lavande, conçue pour les blanchisseries, pressings et hôtels. Formule à haut rendement pour cycles industriels, économies de produit et résultats impeccables sur grandes charges. Conditionnement : 10L.",
    descriptionEn: "Professional 10 L solution scented with Lavender, designed for laundries, dry cleaners and hotels. High-yield formula for industrial cycles, product savings and impeccable results on large loads. Packaging: 10L.",
    descriptionAr: "حل احترافي 10 لتر معطر بلافندر، مصمم للمغاسل والكوي والفنادق. تركيبة عالية الإنتاجية للدورات الصناعية، توفير في المنتج ونتائج لا تشوبها شائبة على الحمولات الكبيرة. العبوة: 10L.",
    featuresFr: ["Format Pro 10L économique", "Parfum Lavande durable", "Rendement professionnel"],
    featuresEn: ["Pro 10L Economical Format", "Long-lasting Lavender", "Professional yield"],
    featuresAr: ["حجم احترافي 10 لتر اقتصادي", "عطر لافندر دائم", "إنتاجية مهنية"],
  },
  {
    id: "gel-machine-ocean-10-l",
    nameFr: "Gel Machine Océan",
    nameEn: "Machine Gel Ocean",
    nameAr: "جل غسالة أوشن",
    category: "industrial",
    subCategory: "laundry",
    size: "10L",
    imageFilename: "GEL MACHINE OCEAN 10L",
    descriptionFr: "Bidon professionnel 10 L au parfum Marine intense, pensé pour les usages HORECA et industriels. Concentration optimisée pour un lavage économique avec une fraîcheur durable sur le linge de service. Conditionnement : 10L.",
    descriptionEn: "Professional 10 L drum with intense Marine fragrance, designed for HORECA and industrial use. Optimized concentration for cost-efficient washing with lasting freshness on service linen. Packaging: 10L.",
    descriptionAr: "عبوة احترافية 10 لتر بعطر بحري مكثف، مصممة للاستخدام في الفنادق والمطاعم والصناعة. تركيز محسّن للغسيل الاقتصادي مع نضارة دائمة على بياضات الخدمة. العبوة: 10L.",
    featuresFr: ["Bidon Pro 10L Marine", "Concentré ultra-puissant", "Idéal HORECA & blanchisseries"],
    featuresEn: ["10L Pro Marine Container", "Ultra-powerful concentrate", "Ideal HORECA & laundries"],
    featuresAr: ["عبوة احترافية 10 لتر بحرية", "تركيز فائق القوة", "مثالي للفنادق والمغاسل"],
  },
  {
    id: "gel-machine-savon-de-marseille-10-l",
    nameFr: "Gel Machine Savon de Marseille",
    nameEn: "Machine Gel Marseille Soap",
    nameAr: "جل غسالة صابون مرسيليا",
    category: "industrial",
    subCategory: "laundry",
    size: "10L",
    imageFilename: "GEL MACHINE SAVON DE MARSEILLE 10L",
    descriptionFr: "Format professionnel 10 L à la formule traditionnelle Savon de Marseille, idéal pour les structures qui privilégient des solutions hypoallergéniques. Lave en profondeur sans laisser de résidus, parfait pour le linge de chambre et de table. Conditionnement : 10L.",
    descriptionEn: "Professional 10 L format with traditional Marseille Soap formula, ideal for facilities favoring hypoallergenic solutions. Deep cleansing without residue, perfect for bed and table linen. Packaging: 10L.",
    descriptionAr: "حجم احترافي 10 لتر بتركيبة صابون مرسيليا التقليدية، مثالي للمنشآت التي تفضل الحلول المضادة للحساسية. تنظيف عميق دون ترك بقايا، مثالي لبياضات الغرف والطاولات. العبوة: 10L.",
    featuresFr: ["10L Savon de Marseille Pro", "Tradition & efficacité", "Pour usage intensif"],
    featuresEn: ["10L Pro Marseille Soap", "Tradition & efficiency", "For intensive use"],
    featuresAr: ["10 لتر صابون مرسيليا احترافي", "تقليد وفعالية", "للاستخدام المكثف"],
  },
  {
    id: "gel-power-oxygene-1-l",
    nameFr: "Gel Power Oxygène",
    nameEn: "Power Oxygen Gel",
    nameAr: "جل باور أكسجين",
    category: "retail",
    subCategory: "laundry",
    size: "1L",
    imageFilename: "POWER OXYGEN 1 L",
    descriptionFr: "Détachant et lessive booster à l'oxygène actif, qui ravive les blancs et préserve l'éclat des couleurs sans chlore agressif. Action ciblée sur les taches organiques (vin, café, herbe, transpiration) en pré-traitement ou directement en machine. Conditionnement : 1L.",
    descriptionEn: "Active-oxygen stain remover and booster, reviving whites and preserving color brilliance without harsh chlorine. Targeted action on organic stains (wine, coffee, grass, sweat) as pre-treatment or directly in the machine. Packaging: 1L.",
    descriptionAr: "مزيل بقع ومعزز غسيل بالأكسجين النشط، يعيد إشراق الأبيض ويحافظ على بريق الألوان دون كلور قاسي. عمل موجه على البقع العضوية (نبيذ، قهوة، عشب، عرق) كمعالجة أولية أو مباشرة في الغسالة. العبوة: 1L.",
    featuresFr: ["Action Oxygène Active", "Ravive le blanc & couleurs", "Sans chlore agressif"],
    featuresEn: ["Active Oxygen Action", "Revives whites & colors", "No harsh chlorine"],
    featuresAr: ["مفعول الأكسجين النشط", "يعيد إشراق الأبيض والألوان", "بدون كلور قاسي"],
  },
  {
    id: "gel-power-oxygene-3-l",
    nameFr: "Gel Power Oxygène",
    nameEn: "Power Oxygen Gel",
    nameAr: "جل باور أكسجين",
    category: "retail",
    subCategory: "laundry",
    size: "3L",
    imageFilename: "POWER OXYGEN 3 L",
    descriptionFr: "Détachant et lessive booster à l'oxygène actif, qui ravive les blancs et préserve l'éclat des couleurs sans chlore agressif. Action ciblée sur les taches organiques (vin, café, herbe, transpiration) en pré-traitement ou directement en machine. Conditionnement : 3L.",
    descriptionEn: "Active-oxygen stain remover and booster, reviving whites and preserving color brilliance without harsh chlorine. Targeted action on organic stains (wine, coffee, grass, sweat) as pre-treatment or directly in the machine. Packaging: 3L.",
    descriptionAr: "مزيل بقع ومعزز غسيل بالأكسجين النشط، يعيد إشراق الأبيض ويحافظ على بريق الألوان دون كلور قاسي. عمل موجه على البقع العضوية (نبيذ، قهوة، عشب، عرق) كمعالجة أولية أو مباشرة في الغسالة. العبوة: 3L.",
    featuresFr: ["Action Oxygène Active", "Ravive le blanc & couleurs", "Sans chlore agressif"],
    featuresEn: ["Active Oxygen Action", "Revives whites & colors", "No harsh chlorine"],
    featuresAr: ["مفعول الأكسجين النشط", "يعيد إشراق الأبيض والألوان", "بدون كلور قاسي"],
  },
  {
    id: "parfum-de-linge-500-ml",
    nameFr: "Parfum de Linge",
    nameEn: "Laundry Perfume",
    nameAr: "عطر الغسيل",
    category: "retail",
    subCategory: "laundry",
    size: "500ML",
    imageFilename: "PARFUM DE LINGE 500 ML",
    descriptionFr: "Parfum d'intérieur en spray pour textiles, à pulvériser sur le linge propre, les rideaux, les coussins et la literie. Une signature olfactive Olion qui prolonge la fraîcheur lavée durant plusieurs jours, sans tacher ni marquer les tissus. Conditionnement : 500ML.",
    descriptionEn: "Textile spray-on perfume to mist over clean laundry, curtains, cushions and bedding. An Olion olfactory signature that extends washed freshness for several days, without staining or marking fabrics. Packaging: 500ML.",
    descriptionAr: "عطر داخلي بخاخ للأقمشة، يرش على الغسيل النظيف والستائر والوسائد وأغطية السرير. توقيع عطري أوليون يطيل نضارة الغسيل عدة أيام، دون تلطيخ أو ترك آثار على الأقمشة. العبوة: 500ML.",
    featuresFr: ["Parfum intense longue durée", "Sublime tissus & literie", "Signature olfactive Olion"],
    featuresEn: ["Long-lasting intense scent", "Enhances fabrics & bedding", "Olion olfactory signature"],
    featuresAr: ["عطر مكثف طويل الأمد", "يبرز الأقمشة وأغطية السرير", "توقيع عطري أوليون"],
  },
  {
    id: "air-fraiche-aoud-250-ml",
    nameFr: "Désodorisant d'Ambiance Oud",
    nameEn: "Air Fresh Oud",
    nameAr: "معطر جو عود",
    category: "retail",
    subCategory: "home",
    size: "250ML",
    imageFilename: "AIR FRAICHE AOUD 250 ML",
    descriptionFr: "Spray d'ambiance aux notes boisées du Oud oriental, pour créer une atmosphère chaleureuse, luxueuse et reconnaissable. Diffusion fine en micro-gouttelettes qui imprègne durablement les pièces sans saturer l'air. Conditionnement : 250ML.",
    descriptionEn: "Room spray with oriental Oud wood notes, creating a warm, luxurious and recognizable atmosphere. Fine micro-droplet diffusion that lingers in rooms without saturating the air. Packaging: 250ML.",
    descriptionAr: "بخاخ معطر للجو بنفحات العود الشرقي الخشبية، يخلق أجواء دافئة فاخرة ومميزة. انتشار دقيق بقطرات ميكروية يدوم في الغرف دون إشباع الهواء. العبوة: 250ML.",
    featuresFr: ["Parfum Oud luxueux", "Ambiance orientale chaleureuse", "Signature olfactive premium"],
    featuresEn: ["Luxurious Oud Fragrance", "Warm oriental ambiance", "Premium olfactory signature"],
    featuresAr: ["عطر العود الفاخر", "أجواء شرقية دافئة", "توقيع عطري راقي"],
  },
  {
    id: "air-fraiche-aoud-500-ml",
    nameFr: "Désodorisant d'Ambiance Oud",
    nameEn: "Air Fresh Oud",
    nameAr: "معطر جو عود",
    category: "retail",
    subCategory: "home",
    size: "500ML",
    imageFilename: "AIR FRAICHE AOUD 500 ML",
    descriptionFr: "Spray d'ambiance aux notes boisées du Oud oriental, pour créer une atmosphère chaleureuse, luxueuse et reconnaissable. Diffusion fine en micro-gouttelettes qui imprègne durablement les pièces sans saturer l'air. Conditionnement : 500ML.",
    descriptionEn: "Room spray with oriental Oud wood notes, creating a warm, luxurious and recognizable atmosphere. Fine micro-droplet diffusion that lingers in rooms without saturating the air. Packaging: 500ML.",
    descriptionAr: "بخاخ معطر للجو بنفحات العود الشرقي الخشبية، يخلق أجواء دافئة فاخرة ومميزة. انتشار دقيق بقطرات ميكروية يدوم في الغرف دون إشباع الهواء. العبوة: 500ML.",
    featuresFr: ["Parfum Oud luxueux", "Ambiance orientale chaleureuse", "Signature olfactive premium"],
    featuresEn: ["Luxurious Oud Fragrance", "Warm oriental ambiance", "Premium olfactory signature"],
    featuresAr: ["عطر العود الفاخر", "أجواء شرقية دافئة", "توقيع عطري راقي"],
  },
  {
    id: "air-fraiche-fleur-de-shine-500-ml",
    nameFr: "Désodorisant d'Ambiance Floral",
    nameEn: "Air Fresh Floral Shine",
    nameAr: "معطر جو زهور",
    category: "retail",
    subCategory: "home",
    size: "500ML",
    imageFilename: "AIR FRAICHE FLEUR DE SHINE 500 ML",
    descriptionFr: "Spray d'ambiance Floral inspiré d'un bouquet de fleurs blanches, raffiné et discret. Une signature olfactive qui ajoute une touche d'élégance aux espaces de vie et de réception, sans dominer. Conditionnement : 500ML.",
    descriptionEn: "Floral room spray inspired by a refined, discreet white-flower bouquet. An olfactory signature that adds elegance to living and reception spaces, without overpowering. Packaging: 500ML.",
    descriptionAr: "بخاخ معطر للجو بعطر زهري مستوحى من باقة زهور بيضاء، راقٍ وهادئ. توقيع عطري يضيف لمسة من الأناقة لأماكن المعيشة والاستقبال دون أن يطغى. العبوة: 500ML.",
    featuresFr: ["Bouquet floral raffiné", "Élégance discrète", "Diffusion homogène"],
    featuresEn: ["Refined Floral Bouquet", "Subtle elegance", "Even diffusion"],
    featuresAr: ["باقة زهور راقية", "أناقة هادئة", "انتشار متجانس"],
  },
  {
    id: "air-fraiche-fleur-de-shine-250-ml",
    nameFr: "Désodorisant d'Ambiance Floral",
    nameEn: "Air Fresh Floral Shine",
    nameAr: "معطر جو زهور",
    category: "retail",
    subCategory: "home",
    size: "250ML",
    imageFilename: "AIR FRAICHE FLEURE DE SHINE 250ML",
    descriptionFr: "Spray d'ambiance Floral inspiré d'un bouquet de fleurs blanches, raffiné et discret. Une signature olfactive qui ajoute une touche d'élégance aux espaces de vie et de réception, sans dominer. Conditionnement : 250ML.",
    descriptionEn: "Floral room spray inspired by a refined, discreet white-flower bouquet. An olfactory signature that adds elegance to living and reception spaces, without overpowering. Packaging: 250ML.",
    descriptionAr: "بخاخ معطر للجو بعطر زهري مستوحى من باقة زهور بيضاء، راقٍ وهادئ. توقيع عطري يضيف لمسة من الأناقة لأماكن المعيشة والاستقبال دون أن يطغى. العبوة: 250ML.",
    featuresFr: ["Bouquet floral raffiné", "Élégance discrète", "Diffusion homogène"],
    featuresEn: ["Refined Floral Bouquet", "Subtle elegance", "Even diffusion"],
    featuresAr: ["باقة زهور راقية", "أناقة هادئة", "انتشار متجانس"],
  },
  {
    id: "air-fraiche-fruit-500-ml",
    nameFr: "Désodorisant d'Ambiance Fruité",
    nameEn: "Air Fresh Fruit",
    nameAr: "معطر جو فواكه",
    category: "retail",
    subCategory: "home",
    size: "500ML",
    imageFilename: "AIR FRAICHE FRUIT 500 ML",
    descriptionFr: "Spray d'ambiance Fruité aux notes de fruits gourmands, qui apporte une touche de vitalité et de bonne humeur aux espaces de vie. Sa formule pulvérise une fine brume qui rafraîchit immédiatement l'atmosphère. Conditionnement : 500ML.",
    descriptionEn: "Fruity room spray with gourmet fruit notes, bringing vitality and good mood to living spaces. Its formula sprays a fine mist that instantly refreshes the atmosphere. Packaging: 500ML.",
    descriptionAr: "بخاخ معطر للجو بعطر فواكه شهية، يضفي لمسة من الحيوية والمزاج الطيب على أماكن المعيشة. تركيبته ترش رذاذاً ناعماً ينعش الأجواء فوراً. العبوة: 500ML.",
    featuresFr: ["Bouquet de fruits frais", "Énergie & vitalité", "Pulvérisation fine"],
    featuresEn: ["Fresh Fruits Bouquet", "Energy & vitality", "Fine mist spray"],
    featuresAr: ["باقة فواكه طازجة", "طاقة وحيوية", "رذاذ ناعم"],
  },
  {
    id: "air-fraiche-fruit-250-ml",
    nameFr: "Désodorisant d'Ambiance Fruité",
    nameEn: "Air Fresh Fruit",
    nameAr: "معطر جو فواكه",
    category: "retail",
    subCategory: "home",
    size: "250ML",
    imageFilename: "AIR-FRESH FRUIT 250 ML",
    descriptionFr: "Spray d'ambiance Fruité aux notes de fruits gourmands, qui apporte une touche de vitalité et de bonne humeur aux espaces de vie. Sa formule pulvérise une fine brume qui rafraîchit immédiatement l'atmosphère. Conditionnement : 250ML.",
    descriptionEn: "Fruity room spray with gourmet fruit notes, bringing vitality and good mood to living spaces. Its formula sprays a fine mist that instantly refreshes the atmosphere. Packaging: 250ML.",
    descriptionAr: "بخاخ معطر للجو بعطر فواكه شهية، يضفي لمسة من الحيوية والمزاج الطيب على أماكن المعيشة. تركيبته ترش رذاذاً ناعماً ينعش الأجواء فوراً. العبوة: 250ML.",
    featuresFr: ["Bouquet de fruits frais", "Énergie & vitalité", "Pulvérisation fine"],
    featuresEn: ["Fresh Fruits Bouquet", "Energy & vitality", "Fine mist spray"],
    featuresAr: ["باقة فواكه طازجة", "طاقة وحيوية", "رذاذ ناعم"],
  },
  {
    id: "air-fraiche-lavande-500-ml",
    nameFr: "Désodorisant d'Ambiance Lavande",
    nameEn: "Air Fresh Lavender",
    nameAr: "معطر جو لافندر",
    category: "retail",
    subCategory: "home",
    size: "500ML",
    imageFilename: "AIR FRAICHE LAVANDE 500 ML",
    descriptionFr: "Spray d'ambiance à la Lavande, qui apporte une fraîcheur florale et apaisante à votre intérieur. Idéal pour chambres, salles de bain et bureaux — son action neutralise les mauvaises odeurs plutôt que de les masquer. Conditionnement : 500ML.",
    descriptionEn: "Lavender room spray bringing soothing floral freshness to your home. Ideal for bedrooms, bathrooms and offices — its action neutralizes bad odors rather than masking them. Packaging: 500ML.",
    descriptionAr: "بخاخ معطر للجو بلافندر، يضفي نضارة زهرية مهدئة على منزلك. مثالي لغرف النوم والحمامات والمكاتب — عمله يحيد الروائح الكريهة بدلاً من تغطيتها. العبوة: 500ML.",
    featuresFr: ["Parfum Lavande relaxant", "Diffusion longue durée", "Anti-odeurs efficace"],
    featuresEn: ["Relaxing Lavender Scent", "Long-lasting diffusion", "Effective odor neutralizer"],
    featuresAr: ["عطر لافندر مريح", "انتشار طويل الأمد", "مضاد للروائح فعال"],
  },
  {
    id: "air-fraiche-lavande-250-ml",
    nameFr: "Désodorisant d'Ambiance Lavande",
    nameEn: "Air Fresh Lavender",
    nameAr: "معطر جو لافندر",
    category: "retail",
    subCategory: "home",
    size: "250ML",
    imageFilename: "AIR FRAICHE LAVANDE 250 ML",
    descriptionFr: "Spray d'ambiance à la Lavande, qui apporte une fraîcheur florale et apaisante à votre intérieur. Idéal pour chambres, salles de bain et bureaux — son action neutralise les mauvaises odeurs plutôt que de les masquer. Conditionnement : 250ML.",
    descriptionEn: "Lavender room spray bringing soothing floral freshness to your home. Ideal for bedrooms, bathrooms and offices — its action neutralizes bad odors rather than masking them. Packaging: 250ML.",
    descriptionAr: "بخاخ معطر للجو بلافندر، يضفي نضارة زهرية مهدئة على منزلك. مثالي لغرف النوم والحمامات والمكاتب — عمله يحيد الروائح الكريهة بدلاً من تغطيتها. العبوة: 250ML.",
    featuresFr: ["Parfum Lavande relaxant", "Diffusion longue durée", "Anti-odeurs efficace"],
    featuresEn: ["Relaxing Lavender Scent", "Long-lasting diffusion", "Effective odor neutralizer"],
    featuresAr: ["عطر لافندر مريح", "انتشار طويل الأمد", "مضاد للروائح فعال"],
  },
  {
    id: "air-fraiche-ocean-250-ml",
    nameFr: "Désodorisant d'Ambiance Océan",
    nameEn: "Air Fresh Ocean",
    nameAr: "معطر جو أوشن",
    category: "retail",
    subCategory: "home",
    size: "250ML",
    imageFilename: "AIR FRAICHE OCEAN 250ML",
    descriptionFr: "Spray d'ambiance aux accords marins vivifiants, évocation directe d'une brise côtière tunisienne. Parfait pour aérer visuellement les espaces fermés et créer une sensation d'air pur tonifiant. Conditionnement : 250ML.",
    descriptionEn: "Room spray with invigorating marine notes, a direct evocation of a Tunisian coastal breeze. Perfect to refresh enclosed spaces and create a tonifying sense of pure air. Packaging: 250ML.",
    descriptionAr: "بخاخ معطر للجو بنفحات بحرية منعشة، استحضار مباشر لنسيم الساحل التونسي. مثالي لتجديد الأماكن المغلقة بصرياً وخلق إحساس بالهواء النقي المنعش. العبوة: 250ML.",
    featuresFr: ["Brise marine vivifiante", "Sensation d'air pur", "Élimine les odeurs tenaces"],
    featuresEn: ["Invigorating Sea Breeze", "Pure air sensation", "Removes stubborn odors"],
    featuresAr: ["نسيم بحري منعش", "إحساس الهواء النقي", "يزيل الروائح العنيدة"],
  },
  {
    id: "air-fraiche-ocean-500-ml",
    nameFr: "Désodorisant d'Ambiance Océan",
    nameEn: "Air Fresh Ocean",
    nameAr: "معطر جو أوشن",
    category: "retail",
    subCategory: "home",
    size: "500ML",
    imageFilename: "AIR FRAICHE OCEAN 500 ML",
    descriptionFr: "Spray d'ambiance aux accords marins vivifiants, évocation directe d'une brise côtière tunisienne. Parfait pour aérer visuellement les espaces fermés et créer une sensation d'air pur tonifiant. Conditionnement : 500ML.",
    descriptionEn: "Room spray with invigorating marine notes, a direct evocation of a Tunisian coastal breeze. Perfect to refresh enclosed spaces and create a tonifying sense of pure air. Packaging: 500ML.",
    descriptionAr: "بخاخ معطر للجو بنفحات بحرية منعشة، استحضار مباشر لنسيم الساحل التونسي. مثالي لتجديد الأماكن المغلقة بصرياً وخلق إحساس بالهواء النقي المنعش. العبوة: 500ML.",
    featuresFr: ["Brise marine vivifiante", "Sensation d'air pur", "Élimine les odeurs tenaces"],
    featuresEn: ["Invigorating Sea Breeze", "Pure air sensation", "Removes stubborn odors"],
    featuresAr: ["نسيم بحري منعش", "إحساس الهواء النقي", "يزيل الروائح العنيدة"],
  },
  {
    id: "desodorisant-fawah-1-l",
    nameFr: "Désodorisant Fawah",
    nameEn: "Fawah Deodorant",
    nameAr: "معطر فواح",
    category: "retail",
    subCategory: "home",
    size: "1L",
    imageFilename: "DESODORISSANT FAWAH 1L",
    descriptionFr: "Désodorisant liquide concentré au parfum Fawah authentique, à diluer pour le nettoyage des sols et surfaces. Une senteur orientale persistante qui transforme l'expérience du ménage en moment olfactif. Conditionnement : 1L.",
    descriptionEn: "Concentrated liquid deodorizer with authentic Fawah fragrance, to dilute for floor and surface cleaning. A lingering oriental scent that turns cleaning into an olfactory experience. Packaging: 1L.",
    descriptionAr: "معطر سائل مركز بعطر فواح أصيل، للتخفيف في تنظيف الأرضيات والأسطح. عطر شرقي دائم يحول تجربة التنظيف إلى لحظة عطرية. العبوة: 1L.",
    featuresFr: ["Parfum Fawah intense", "Neutralise les odeurs fortes", "Maison, sanitaires, pro"],
    featuresEn: ["Intense Fawah Fragrance", "Neutralizes strong odors", "Home, sanitary, pro"],
    featuresAr: ["عطر فواح مكثف", "يحيد الروائح القوية", "منزل، حمامات، مهني"],
  },
  {
    id: "desodorisant-fawah-5-l",
    nameFr: "Désodorisant Fawah",
    nameEn: "Fawah Deodorant",
    nameAr: "معطر فواح",
    category: "industrial",
    subCategory: "home",
    size: "5L",
    imageFilename: "DESODORISSANT FAWAH 5L",
    descriptionFr: "Désodorisant liquide concentré au parfum Fawah authentique, à diluer pour le nettoyage des sols et surfaces. Une senteur orientale persistante qui transforme l'expérience du ménage en moment olfactif. Conditionnement : 5L.",
    descriptionEn: "Concentrated liquid deodorizer with authentic Fawah fragrance, to dilute for floor and surface cleaning. A lingering oriental scent that turns cleaning into an olfactory experience. Packaging: 5L.",
    descriptionAr: "معطر سائل مركز بعطر فواح أصيل، للتخفيف في تنظيف الأرضيات والأسطح. عطر شرقي دائم يحول تجربة التنظيف إلى لحظة عطرية. العبوة: 5L.",
    featuresFr: ["Parfum Fawah intense", "Neutralise les odeurs fortes", "Maison, sanitaires, pro"],
    featuresEn: ["Intense Fawah Fragrance", "Neutralizes strong odors", "Home, sanitary, pro"],
    featuresAr: ["عطر فواح مكثف", "يحيد الروائح القوية", "منزل، حمامات، مهني"],
  },
  {
    id: "desodorisant-fleur-1-l",
    nameFr: "Désodorisant Fleur",
    nameEn: "Floral Deodorant",
    nameAr: "معطر زهور",
    category: "retail",
    subCategory: "home",
    size: "1L",
    imageFilename: "DESODORISSANT FLEUR 1L",
    descriptionFr: "Désodorisant liquide concentré aux notes florales délicates, conçu pour parfumer durablement les sols après le lavage. À utiliser pur ou dilué, il laisse une fragrance enveloppante qui dure des heures. Conditionnement : 1L.",
    descriptionEn: "Concentrated liquid deodorizer with delicate floral notes, designed to perfume floors after washing for hours. Use neat or diluted, it leaves an enveloping fragrance that lasts. Packaging: 1L.",
    descriptionAr: "معطر سائل مركز بنفحات زهرية رقيقة، مصمم لتعطير الأرضيات بعد الغسيل لساعات. يستعمل نقياً أو مخففاً، يترك عبقاً محيطاً يدوم طويلاً. العبوة: 1L.",
    featuresFr: ["Bouquet floral délicat", "Ambiance fraîche et propre", "Concentré actif"],
    featuresEn: ["Delicate Floral Bouquet", "Fresh clean ambiance", "Active concentrate"],
    featuresAr: ["باقة زهور رقيقة", "أجواء نظيفة منعشة", "مركز نشط"],
  },
  {
    id: "desodorisant-fleur-5-l",
    nameFr: "Désodorisant Fleur",
    nameEn: "Floral Deodorant",
    nameAr: "معطر زهور",
    category: "industrial",
    subCategory: "home",
    size: "5L",
    imageFilename: "DESODORISSANT FLEUR 5L",
    descriptionFr: "Désodorisant liquide concentré aux notes florales délicates, conçu pour parfumer durablement les sols après le lavage. À utiliser pur ou dilué, il laisse une fragrance enveloppante qui dure des heures. Conditionnement : 5L.",
    descriptionEn: "Concentrated liquid deodorizer with delicate floral notes, designed to perfume floors after washing for hours. Use neat or diluted, it leaves an enveloping fragrance that lasts. Packaging: 5L.",
    descriptionAr: "معطر سائل مركز بنفحات زهرية رقيقة، مصمم لتعطير الأرضيات بعد الغسيل لساعات. يستعمل نقياً أو مخففاً، يترك عبقاً محيطاً يدوم طويلاً. العبوة: 5L.",
    featuresFr: ["Bouquet floral délicat", "Ambiance fraîche et propre", "Concentré actif"],
    featuresEn: ["Delicate Floral Bouquet", "Fresh clean ambiance", "Active concentrate"],
    featuresAr: ["باقة زهور رقيقة", "أجواء نظيفة منعشة", "مركز نشط"],
  },
  {
    id: "desodorisant-ocean-1-l",
    nameFr: "Désodorisant Océan",
    nameEn: "Ocean Deodorant",
    nameAr: "معطر أوشن",
    category: "retail",
    subCategory: "home",
    size: "1L",
    imageFilename: "DESODORISSANT OCEAN 1L",
    descriptionFr: "Désodorisant liquide concentré à la fraîcheur Marine, idéal pour les espaces à fort passage : entrées, halls et zones de service. Effet purifiant immédiat qui élimine les odeurs persistantes. Conditionnement : 1L.",
    descriptionEn: "Concentrated liquid deodorizer with Marine freshness, ideal for high-traffic spaces: entrances, halls and service areas. Immediate purifying effect that removes persistent odors. Packaging: 1L.",
    descriptionAr: "معطر سائل مركز بنضارة بحرية، مثالي للأماكن ذات الحركة الكثيفة: المداخل والقاعات ومناطق الخدمة. تأثير منقي فوري يزيل الروائح العنيدة. العبوة: 1L.",
    featuresFr: ["Fraîcheur Marine continue", "Effet purifiant immédiat", "Idéal espaces partagés"],
    featuresEn: ["Continuous Marine Freshness", "Immediate purifying effect", "Ideal shared spaces"],
    featuresAr: ["نضارة بحرية مستمرة", "تأثير منقي فوري", "مثالي للأماكن المشتركة"],
  },
  {
    id: "desodorisant-ocean-5-l",
    nameFr: "Désodorisant Océan",
    nameEn: "Ocean Deodorant",
    nameAr: "معطر أوشن",
    category: "industrial",
    subCategory: "home",
    size: "5L",
    imageFilename: "DESODORISSANT OCEAN 5L",
    descriptionFr: "Désodorisant liquide concentré à la fraîcheur Marine, idéal pour les espaces à fort passage : entrées, halls et zones de service. Effet purifiant immédiat qui élimine les odeurs persistantes. Conditionnement : 5L.",
    descriptionEn: "Concentrated liquid deodorizer with Marine freshness, ideal for high-traffic spaces: entrances, halls and service areas. Immediate purifying effect that removes persistent odors. Packaging: 5L.",
    descriptionAr: "معطر سائل مركز بنضارة بحرية، مثالي للأماكن ذات الحركة الكثيفة: المداخل والقاعات ومناطق الخدمة. تأثير منقي فوري يزيل الروائح العنيدة. العبوة: 5L.",
    featuresFr: ["Fraîcheur Marine continue", "Effet purifiant immédiat", "Idéal espaces partagés"],
    featuresEn: ["Continuous Marine Freshness", "Immediate purifying effect", "Ideal shared spaces"],
    featuresAr: ["نضارة بحرية مستمرة", "تأثير منقي فوري", "مثالي للأماكن المشتركة"],
  },
  {
    id: "gel-wc-750-ml",
    nameFr: "Gel WC",
    nameEn: "WC Gel",
    nameAr: "جل المرحاض",
    category: "retail",
    subCategory: "home",
    size: "750ML",
    imageFilename: "WC GEL 750ML",
    descriptionFr: "Gel WC épais détartrant qui adhère aux parois et sous le rebord pour une action prolongée. Élimine le tartre, les traces et les bactéries en une application, tout en laissant un parfum frais qui dure des heures. Conditionnement : 750ML.",
    descriptionEn: "Thick descaling WC gel that clings to walls and under the rim for prolonged action. Removes limescale, stains and bacteria in one application, while leaving a fresh scent that lasts for hours. Packaging: 750ML.",
    descriptionAr: "جل مرحاض كثيف مزيل للترسبات يلتصق بالجدران وتحت الحافة لمفعول طويل. يزيل الكلس والآثار والبكتيريا في تطبيق واحد، تاركاً عطراً منعشاً يدوم لساعات. العبوة: 750ML.",
    featuresFr: ["Action détartrante puissante", "Adhère sous le rebord", "Fraîcheur durable"],
    featuresEn: ["Powerful descaling action", "Sticks under the rim", "Lasting freshness"],
    featuresAr: ["إزالة الترسبات بقوة", "يلتصق تحت الحافة", "نضارة دائمة"],
  },
  {
    id: "javel-1-l",
    nameFr: "Eau de Javel",
    nameEn: "Bleach",
    nameAr: "ماء جافيل",
    category: "retail",
    subCategory: "home",
    size: "1L",
    imageFilename: "JAVEL 1L",
    descriptionFr: "Eau de Javel haute concentration, certifiée pour la désinfection des sols, sanitaires et linge blanc. Élimine 99,9 % des bactéries, virus et moisissures, et redonne aux blancs leur éclat d'origine. Conditionnement : 1L.",
    descriptionEn: "High-concentration Bleach, certified for floor, sanitary and white-laundry disinfection. Eliminates 99.9% of bacteria, viruses and mold, and restores original brilliance to whites. Packaging: 1L.",
    descriptionAr: "ماء جافيل عالي التركيز، معتمد لتعقيم الأرضيات والحمامات والغسيل الأبيض. يقضي على 99.9% من البكتيريا والفيروسات والعفن، ويعيد للأبيض بريقه الأصلي. العبوة: 1L.",
    featuresFr: ["Désinfection puissante", "Élimine 99% des bactéries", "Blanchiment éclatant"],
    featuresEn: ["Powerful Disinfection", "Kills 99% of bacteria", "Brilliant whitening"],
    featuresAr: ["تعقيم قوي", "يقضي على 99% من البكتيريا", "تبييض ساطع"],
  },
  {
    id: "javel-5-l",
    nameFr: "Eau de Javel",
    nameEn: "Bleach",
    nameAr: "ماء جافيل",
    category: "industrial",
    subCategory: "home",
    size: "5L",
    imageFilename: "JAVEL 5L",
    descriptionFr: "Eau de Javel haute concentration, certifiée pour la désinfection des sols, sanitaires et linge blanc. Élimine 99,9 % des bactéries, virus et moisissures, et redonne aux blancs leur éclat d'origine. Conditionnement : 5L.",
    descriptionEn: "High-concentration Bleach, certified for floor, sanitary and white-laundry disinfection. Eliminates 99.9% of bacteria, viruses and mold, and restores original brilliance to whites. Packaging: 5L.",
    descriptionAr: "ماء جافيل عالي التركيز، معتمد لتعقيم الأرضيات والحمامات والغسيل الأبيض. يقضي على 99.9% من البكتيريا والفيروسات والعفن، ويعيد للأبيض بريقه الأصلي. العبوة: 5L.",
    featuresFr: ["Désinfection puissante", "Élimine 99% des bactéries", "Blanchiment éclatant"],
    featuresEn: ["Powerful Disinfection", "Kills 99% of bacteria", "Brilliant whitening"],
    featuresAr: ["تعقيم قوي", "يقضي على 99% من البكتيريا", "تبييض ساطع"],
  },
  {
    id: "lave-vitres-500-ml",
    nameFr: "Nettoyant Vitres",
    nameEn: "Glass Cleaner",
    nameAr: "منظف الزجاج",
    category: "retail",
    subCategory: "home",
    size: "500ML",
    imageFilename: "LAVE VITRE 500 ML",
    descriptionFr: "Nettoyant vitres et surfaces brillantes à séchage ultra-rapide, qui élimine traces de doigts, projections et poussière sans laisser de voile. Adapté également aux miroirs, inox poli, écrans et acier laqué. Conditionnement : 500ML.",
    descriptionEn: "Ultra-fast-drying glass and shiny-surface cleaner, removing fingerprints, splashes and dust without leaving a film. Also suitable for mirrors, polished stainless steel, screens and lacquered surfaces. Packaging: 500ML.",
    descriptionAr: "منظف زجاج وأسطح لامعة بتجفيف فائق السرعة، يزيل آثار الأصابع والرذاذ والغبار دون ترك طبقة. مناسب أيضاً للمرايا والفولاذ المصقول والشاشات والأسطح المطلية. العبوة: 500ML.",
    featuresFr: ["Brillance sans traces", "Séchage ultra-rapide", "Vitres, miroirs, inox"],
    featuresEn: ["Streak-free Shine", "Ultra-fast drying", "Glass, mirrors, stainless"],
    featuresAr: ["بريق بلا آثار", "تجفيف فائق السرعة", "زجاج، مرايا، فولاذ"],
  },
  {
    id: "olion-tox-insecticide-5-l",
    nameFr: "Olion Tox — Insecticide",
    nameEn: "Olion Tox Insecticide",
    nameAr: "مبيد حشري أوليون توكس",
    category: "industrial",
    subCategory: "home",
    size: "5L",
    imageFilename: "OLION TOX 5L",
    descriptionFr: "Insecticide professionnel longue durée pour mouches, moustiques, cafards et fourmis. Format Pro 5 L pour traitement étendu d'espaces intérieurs et extérieurs ; à utiliser dilué selon les indications. Conditionnement : 5L.",
    descriptionEn: "Long-lasting professional insecticide against flies, mosquitoes, cockroaches and ants. 5 L Pro format for extended treatment of indoor and outdoor spaces; use diluted as instructed. Packaging: 5L.",
    descriptionAr: "مبيد حشري احترافي طويل المدى ضد الذباب والبعوض والصراصير والنمل. حجم احترافي 5 لتر للمعالجة الموسعة للأماكن الداخلية والخارجية؛ يستعمل مخففاً حسب الإرشادات. العبوة: 5L.",
    featuresFr: ["Action insecticide longue durée", "Espaces intérieurs & extérieurs", "Format Pro 5L"],
    featuresEn: ["Long-lasting insecticide action", "Indoor & outdoor spaces", "5L Pro Format"],
    featuresAr: ["مفعول مبيد طويل الأمد", "أماكن داخلية وخارجية", "حجم احترافي 5 لتر"],
  },
  {
    id: "apres-shampoing-noix-de-coco-5-l",
    nameFr: "Après-Shampoing Noix de Coco",
    nameEn: "Coconut Conditioner",
    nameAr: "بلسم جوز الهند",
    category: "industrial",
    subCategory: "personal-care",
    size: "5L",
    imageFilename: "APRES SHAMPOING NOIX DE COCO 5 L",
    descriptionFr: "Après-shampoing professionnel enrichi en extrait de Noix de Coco, qui démêle, hydrate et discipline tous types de cheveux. Format Pro 5 L pour salons et instituts, sans alourdir la fibre capillaire. Conditionnement : 5L.",
    descriptionEn: "Professional conditioner enriched with Coconut extract, detangling, hydrating and disciplining all hair types. 5 L Pro format for salons and institutes, without weighing hair down. Packaging: 5L.",
    descriptionAr: "بلسم احترافي مدعم بمستخلص جوز الهند، يفك التشابك ويرطب ويرتب جميع أنواع الشعر. حجم احترافي 5 لتر للصالونات والمعاهد، دون إثقال الشعر. العبوة: 5L.",
    featuresFr: ["Enrichi à la Noix de Coco", "Démêle sans alourdir", "Brillance & douceur"],
    featuresEn: ["Enriched with Coconut", "Detangles without weighing down", "Shine & softness"],
    featuresAr: ["مدعم بجوز الهند", "يفك التشابك دون ثقل", "لمعان ونعومة"],
  },
  {
    id: "gel-douche-la-rose-5-l",
    nameFr: "Gel Douche à la Rose",
    nameEn: "Rose Shower Gel",
    nameAr: "جل استحمام بالورد",
    category: "retail",
    subCategory: "personal-care",
    size: "5L",
    imageFilename: "GEL DOUCHE LA ROSE 5L",
    descriptionFr: "Gel douche professionnel parfumé à la Rose de Damas, qui transforme la douche en moment cocooning. Sa mousse onctueuse hydrate la peau et libère un parfum élégant et persistant — bidon 5 L pour SPA, hôtels et instituts. Conditionnement : 5L.",
    descriptionEn: "Professional shower gel scented with Damascus Rose, turning showering into a cocooning moment. Its creamy foam hydrates skin and releases an elegant, lasting fragrance — 5 L drum for SPAs, hotels and institutes. Packaging: 5L.",
    descriptionAr: "جل استحمام احترافي بعطر ورد دمشقي، يحول الاستحمام إلى لحظة دلال. رغوته الكريمية ترطب البشرة وتطلق عطراً أنيقاً دائماً — عبوة 5 لتر للسبا والفنادق والمعاهد. العبوة: 5L.",
    featuresFr: ["Parfum Rose enveloppant", "Mousse onctueuse hydratante", "Bidon Pro 5L"],
    featuresEn: ["Enveloping Rose Scent", "Rich moisturizing foam", "5L Pro Container"],
    featuresAr: ["عطر الورد المغلف", "رغوة كثيفة مرطبة", "عبوة احترافية 5 لتر"],
  },
  {
    id: "gel-douche-ocean-bleu-5-l",
    nameFr: "Gel Douche Océan Bleu",
    nameEn: "Blue Ocean Shower Gel",
    nameAr: "جل استحمام أوشن",
    category: "industrial",
    subCategory: "personal-care",
    size: "5L",
    imageFilename: "GEL DOUCH OCEAN 5L",
    descriptionFr: "Gel douche professionnel aux accords marins tonifiants, idéal pour un réveil énergisant. Mousse abondante, formule respectueuse de l'épiderme et fraîcheur prolongée — format Pro 5 L pour usage intensif. Conditionnement : 5L.",
    descriptionEn: "Professional shower gel with invigorating marine notes, ideal for an energizing wake-up. Abundant foam, skin-respectful formula and prolonged freshness — 5 L Pro format for intensive use. Packaging: 5L.",
    descriptionAr: "جل استحمام احترافي بنفحات بحرية منعشة، مثالي لاستيقاظ مفعم بالطاقة. رغوة وفيرة، تركيبة محترمة للبشرة ونضارة ممتدة — حجم احترافي 5 لتر للاستخدام المكثف. العبوة: 5L.",
    featuresFr: ["Énergie Marine pure", "Sensation tonifiante", "Volume Pro économique"],
    featuresEn: ["Pure Marine Energy", "Tonifying sensation", "Pro Economical Volume"],
    featuresAr: ["طاقة بحرية نقية", "إحساس منعش", "حجم احترافي اقتصادي"],
  },
  {
    id: "lave-main-blanc-500-ml",
    nameFr: "Savon Mains Blanc",
    nameEn: "White Hand Soap",
    nameAr: "صابون اليدين أبيض",
    category: "retail",
    subCategory: "personal-care",
    size: "500ML",
    imageFilename: "LAVE MAIN BLANC 500 ML",
    descriptionFr: "Savon liquide pour les mains, formule classique blanche au pH neutre, doux et hydratant pour usage fréquent. Idéal pour la salle de bain familiale, restaurants, bureaux et espaces communs. Conditionnement : 500ML.",
    descriptionEn: "Liquid hand soap, classic neutral-pH white formula, gentle and moisturizing for frequent use. Ideal for family bathrooms, restaurants, offices and shared spaces. Packaging: 500ML.",
    descriptionAr: "صابون يدين سائل، تركيبة بيضاء كلاسيكية متعادلة الحموضة، لطيفة ومرطبة للاستخدام المتكرر. مثالي للحمامات العائلية والمطاعم والمكاتب والأماكن المشتركة. العبوة: 500ML.",
    featuresFr: ["Formule délicate quotidienne", "Mousse crémeuse", "Hygiène respectueuse"],
    featuresEn: ["Gentle Daily Formula", "Creamy foam", "Respectful hygiene"],
    featuresAr: ["تركيبة لطيفة يومية", "رغوة كريمية", "نظافة محترمة"],
  },
  {
    id: "lave-main-fruit-rouge-1-l",
    nameFr: "Savon Mains Fruits Rouges",
    nameEn: "Red Fruit Hand Soap",
    nameAr: "صابون اليدين فواكه حمراء",
    category: "retail",
    subCategory: "personal-care",
    size: "1L",
    imageFilename: "LAVE MAIN FRUIT ROUGE 1 L",
    descriptionFr: "Savon liquide gourmand aux Fruits Rouges, qui parfume durablement les mains tout en les nettoyant en profondeur. Formule enrichie en agents hydratants pour préserver le confort de la peau, même lavages fréquents. Conditionnement : 1L.",
    descriptionEn: "Gourmet Red Fruits liquid soap, perfuming hands lasting while cleansing deeply. Formula enriched with moisturizers to maintain skin comfort, even with frequent washing. Packaging: 1L.",
    descriptionAr: "صابون يدين سائل شهي بفواكه حمراء، يعطر اليدين بشكل دائم مع تنظيف عميق. تركيبة مدعمة بمرطبات للحفاظ على راحة البشرة حتى مع غسيل متكرر. العبوة: 1L.",
    featuresFr: ["Parfum Fruits Rouges gourmand", "Mousse douce & généreuse", "Hydrate les mains"],
    featuresEn: ["Gourmet Red Fruits Scent", "Soft generous foam", "Hydrates hands"],
    featuresAr: ["عطر فواكه حمراء شهي", "رغوة ناعمة وفيرة", "يرطب اليدين"],
  },
  {
    id: "lave-main-fruit-rouge-5-l",
    nameFr: "Savon Mains Fruits Rouges",
    nameEn: "Red Fruit Hand Soap",
    nameAr: "صابون اليدين فواكه حمراء",
    category: "industrial",
    subCategory: "personal-care",
    size: "5L",
    imageFilename: "LAVE MAIN FRUIT ROUGE 5 L",
    descriptionFr: "Savon liquide gourmand aux Fruits Rouges, qui parfume durablement les mains tout en les nettoyant en profondeur. Formule enrichie en agents hydratants pour préserver le confort de la peau, même lavages fréquents. Conditionnement : 5L.",
    descriptionEn: "Gourmet Red Fruits liquid soap, perfuming hands lasting while cleansing deeply. Formula enriched with moisturizers to maintain skin comfort, even with frequent washing. Packaging: 5L.",
    descriptionAr: "صابون يدين سائل شهي بفواكه حمراء، يعطر اليدين بشكل دائم مع تنظيف عميق. تركيبة مدعمة بمرطبات للحفاظ على راحة البشرة حتى مع غسيل متكرر. العبوة: 5L.",
    featuresFr: ["Parfum Fruits Rouges gourmand", "Mousse douce & généreuse", "Hydrate les mains"],
    featuresEn: ["Gourmet Red Fruits Scent", "Soft generous foam", "Hydrates hands"],
    featuresAr: ["عطر فواكه حمراء شهي", "رغوة ناعمة وفيرة", "يرطب اليدين"],
  },
  {
    id: "lave-main-fruite-500-ml",
    nameFr: "Savon Mains Fruité",
    nameEn: "Fruity Hand Soap",
    nameAr: "صابون اليدين فواكه",
    category: "retail",
    subCategory: "personal-care",
    size: "500ML",
    imageFilename: "LAVE MAIN FRUITE 500 ML",
    descriptionFr: "Savon mains au cocktail de fruits frais, qui apporte une note pétillante à votre rituel d'hygiène. Mousse douce, rinçage rapide et sensation de fraîcheur immédiate — idéal pour cuisines et espaces gourmands. Conditionnement : 500ML.",
    descriptionEn: "Hand soap with a fresh-fruit cocktail, bringing a sparkling note to your hygiene ritual. Soft foam, fast rinsing and immediate freshness — ideal for kitchens and food areas. Packaging: 500ML.",
    descriptionAr: "صابون يدين بكوكتيل فواكه طازجة، يضفي لمسة منعشة على روتين النظافة. رغوة ناعمة، شطف سريع وإحساس فوري بالنضارة — مثالي للمطابخ والأماكن الغذائية. العبوة: 500ML.",
    featuresFr: ["Cocktail fruité dynamique", "Action nettoyante douce", "Plaisir des sens"],
    featuresEn: ["Dynamic Fruity Cocktail", "Gentle cleaning action", "Sensory pleasure"],
    featuresAr: ["كوكتيل فواكه ديناميكي", "تنظيف لطيف", "متعة الحواس"],
  },
  {
    id: "lave-main-lavande-1-l",
    nameFr: "Savon Mains Lavande",
    nameEn: "Lavender Hand Soap",
    nameAr: "صابون اليدين لافندر",
    category: "retail",
    subCategory: "personal-care",
    size: "1L",
    imageFilename: "LAVE MAIN LAVANDE 1000 ML",
    descriptionFr: "Savon liquide à la Lavande aux propriétés apaisantes, parfait pour les peaux qui réagissent aux savons trop parfumés. Nettoie doucement tout en laissant un sillage olfactif relaxant — disponible en 500 ML, 1 L et 5 L. Conditionnement : 1L.",
    descriptionEn: "Lavender liquid soap with soothing properties, perfect for skin that reacts to overly perfumed soaps. Cleans gently while leaving a relaxing olfactory trail — available in 500 ML, 1 L and 5 L. Packaging: 1L.",
    descriptionAr: "صابون سائل بلافندر بخصائص مهدئة، مثالي للبشرة التي تتفاعل مع الصابون شديد التعطير. ينظف بلطف تاركاً عبقاً عطرياً مريحاً — متوفر بـ 500 مل و1 لتر و5 لتر. العبوة: 1L.",
    featuresFr: ["Lavande apaisante", "Pour usage fréquent", "Mains douces & parfumées"],
    featuresEn: ["Soothing Lavender", "For frequent use", "Soft fragrant hands"],
    featuresAr: ["لافندر مهدئ", "للاستخدام المتكرر", "أيدي ناعمة معطرة"],
  },
  {
    id: "lave-main-lavande-5-l",
    nameFr: "Savon Mains Lavande",
    nameEn: "Lavender Hand Soap",
    nameAr: "صابون اليدين لافندر",
    category: "industrial",
    subCategory: "personal-care",
    size: "5L",
    imageFilename: "LAVE MAIN LAVANDE 5 L",
    descriptionFr: "Savon liquide à la Lavande aux propriétés apaisantes, parfait pour les peaux qui réagissent aux savons trop parfumés. Nettoie doucement tout en laissant un sillage olfactif relaxant — disponible en 500 ML, 1 L et 5 L. Conditionnement : 5L.",
    descriptionEn: "Lavender liquid soap with soothing properties, perfect for skin that reacts to overly perfumed soaps. Cleans gently while leaving a relaxing olfactory trail — available in 500 ML, 1 L and 5 L. Packaging: 5L.",
    descriptionAr: "صابون سائل بلافندر بخصائص مهدئة، مثالي للبشرة التي تتفاعل مع الصابون شديد التعطير. ينظف بلطف تاركاً عبقاً عطرياً مريحاً — متوفر بـ 500 مل و1 لتر و5 لتر. العبوة: 5L.",
    featuresFr: ["Lavande apaisante", "Pour usage fréquent", "Mains douces & parfumées"],
    featuresEn: ["Soothing Lavender", "For frequent use", "Soft fragrant hands"],
    featuresAr: ["لافندر مهدئ", "للاستخدام المتكرر", "أيدي ناعمة معطرة"],
  },
  {
    id: "lave-main-lavande-500-ml",
    nameFr: "Savon Mains Lavande",
    nameEn: "Lavender Hand Soap",
    nameAr: "صابون اليدين لافندر",
    category: "retail",
    subCategory: "personal-care",
    size: "500ML",
    imageFilename: "LAVE MAIN LAVENDE 500 ML",
    descriptionFr: "Savon liquide à la Lavande aux propriétés apaisantes, parfait pour les peaux qui réagissent aux savons trop parfumés. Nettoie doucement tout en laissant un sillage olfactif relaxant — disponible en 500 ML, 1 L et 5 L. Conditionnement : 500ML.",
    descriptionEn: "Lavender liquid soap with soothing properties, perfect for skin that reacts to overly perfumed soaps. Cleans gently while leaving a relaxing olfactory trail — available in 500 ML, 1 L and 5 L. Packaging: 500ML.",
    descriptionAr: "صابون سائل بلافندر بخصائص مهدئة، مثالي للبشرة التي تتفاعل مع الصابون شديد التعطير. ينظف بلطف تاركاً عبقاً عطرياً مريحاً — متوفر بـ 500 مل و1 لتر و5 لتر. العبوة: 500ML.",
    featuresFr: ["Lavande apaisante", "Pour usage fréquent", "Mains douces & parfumées"],
    featuresEn: ["Soothing Lavender", "For frequent use", "Soft fragrant hands"],
    featuresAr: ["لافندر مهدئ", "للاستخدام المتكرر", "أيدي ناعمة معطرة"],
  },
  {
    id: "lave-main-vanille-1-l",
    nameFr: "Savon Mains Vanille",
    nameEn: "Vanilla Hand Soap",
    nameAr: "صابون اليدين فانيليا",
    category: "retail",
    subCategory: "personal-care",
    size: "1L",
    imageFilename: "LAVE MAIN VANILLE 1 L",
    descriptionFr: "Savon mains parfumé à la Vanille, doux et enveloppant, qui transforme le lavage des mains en moment chaleureux. Texture crémeuse, mousse stable et hydratation maintenue — idéal pour les espaces accueil et les SPA. Conditionnement : 1L.",
    descriptionEn: "Vanilla-scented hand soap, soft and enveloping, turning hand washing into a warm moment. Creamy texture, stable foam and maintained hydration — ideal for reception areas and SPAs. Packaging: 1L.",
    descriptionAr: "صابون يدين بعطر الفانيليا، ناعم ومحيط، يحول غسيل اليدين إلى لحظة دافئة. قوام كريمي، رغوة ثابتة وترطيب محفوظ — مثالي لأماكن الاستقبال والسبا. العبوة: 1L.",
    featuresFr: ["Parfum Vanille chaleureux", "Crème nettoyante", "Touche gourmande"],
    featuresEn: ["Warm Vanilla Scent", "Cleansing cream", "Gourmet touch"],
    featuresAr: ["عطر الفانيليا الدافئ", "كريم منظف", "لمسة شهية"],
  },
  {
    id: "lave-main-vanille-5-l",
    nameFr: "Savon Mains Vanille",
    nameEn: "Vanilla Hand Soap",
    nameAr: "صابون اليدين فانيليا",
    category: "industrial",
    subCategory: "personal-care",
    size: "5L",
    imageFilename: "LAVE MAIN VANILLE 5 L",
    descriptionFr: "Savon mains parfumé à la Vanille, doux et enveloppant, qui transforme le lavage des mains en moment chaleureux. Texture crémeuse, mousse stable et hydratation maintenue — idéal pour les espaces accueil et les SPA. Conditionnement : 5L.",
    descriptionEn: "Vanilla-scented hand soap, soft and enveloping, turning hand washing into a warm moment. Creamy texture, stable foam and maintained hydration — ideal for reception areas and SPAs. Packaging: 5L.",
    descriptionAr: "صابون يدين بعطر الفانيليا، ناعم ومحيط، يحول غسيل اليدين إلى لحظة دافئة. قوام كريمي، رغوة ثابتة وترطيب محفوظ — مثالي لأماكن الاستقبال والسبا. العبوة: 5L.",
    featuresFr: ["Parfum Vanille chaleureux", "Crème nettoyante", "Touche gourmande"],
    featuresEn: ["Warm Vanilla Scent", "Cleansing cream", "Gourmet touch"],
    featuresAr: ["عطر الفانيليا الدافئ", "كريم منظف", "لمسة شهية"],
  },
  {
    id: "shampoing-miel-argan-5-l",
    nameFr: "Shampoing Miel & Argan",
    nameEn: "Honey & Argan Shampoo",
    nameAr: "شامبو العسل والأرغان",
    category: "industrial",
    subCategory: "personal-care",
    size: "5L",
    imageFilename: "SHAMPOING MIEL ARGANT 5L",
    descriptionFr: "Shampoing professionnel enrichi en Miel pur et huile d'Argan, conçu pour nourrir, réparer et faire briller les cheveux secs ou abîmés. Format Pro 5 L pour salons de coiffure et instituts de soin haut de gamme. Conditionnement : 5L.",
    descriptionEn: "Professional shampoo enriched with pure Honey and Argan oil, designed to nourish, repair and shine dry or damaged hair. 5 L Pro format for high-end hair salons and care institutes. Packaging: 5L.",
    descriptionAr: "شامبو احترافي مدعم بالعسل النقي وزيت الأرغان، مصمم لتغذية وإصلاح وتلميع الشعر الجاف أو التالف. حجم احترافي 5 لتر للصالونات ومعاهد العناية الراقية. العبوة: 5L.",
    featuresFr: ["Miel & Argan nourrissants", "Renforce la fibre capillaire", "Brillance soyeuse"],
    featuresEn: ["Nourishing Honey & Argan", "Strengthens hair fiber", "Silky shine"],
    featuresAr: ["عسل وأرغان مغذيان", "يقوي الشعرة", "لمعان حريري"],
  },
  {
    id: "shampoing-pomme-menthe-5-l",
    nameFr: "Shampoing Pomme & Menthe",
    nameEn: "Apple & Mint Shampoo",
    nameAr: "شامبو التفاح والنعناع",
    category: "industrial",
    subCategory: "personal-care",
    size: "5L",
    imageFilename: "SHAMPOING POMME-MENTHE 5L",
    descriptionFr: "Shampoing professionnel au duo Pomme & Menthe, qui rafraîchit le cuir chevelu et apporte du volume aux cheveux fins. Action purifiante anti-pellicules douce, particulièrement adapté aux usages quotidiens. Conditionnement : 5L.",
    descriptionEn: "Professional shampoo with Apple & Mint duo, refreshing the scalp and adding volume to fine hair. Gentle anti-dandruff purifying action, particularly suited to daily use. Packaging: 5L.",
    descriptionAr: "شامبو احترافي بثنائي التفاح والنعناع، ينعش فروة الرأس ويمنح الحجم للشعر الناعم. عمل منقي لطيف مضاد للقشرة، مناسب بشكل خاص للاستخدام اليومي. العبوة: 5L.",
    featuresFr: ["Fraîcheur Pomme-Menthe", "Cuir chevelu revitalisé", "Cheveux légers & brillants"],
    featuresEn: ["Apple-Mint Freshness", "Revitalized scalp", "Light shiny hair"],
    featuresAr: ["نضارة التفاح والنعناع", "فروة رأس منتعشة", "شعر خفيف ولامع"],
  },
];

// Resolve image URL from filename map, fallback to placeholder
export const productsData = rawProducts.map(p => ({
  ...p,
  image: imageMap[p.imageFilename] || PLACEHOLDER_IMAGE,
  hasImage: Boolean(imageMap[p.imageFilename]),
}));

export const categoryNames = {
  retail: { fr: "Gamme Retail", en: "Retail Range", ar: "مجموعة التجزئة" },
  bulk: { fr: "Olion Vrac", en: "Olion Bulk", ar: "أوليون بالجملة" },
  industrial: { fr: "Solutions Industrielles", en: "Industrial Solutions", ar: "الحلول الصناعية" },
  box: { fr: "Olion Box", en: "Olion Box", ar: "صندوق أوليون" }
};

export const subCategoryNames = {
  kitchen: { fr: "Cuisine", en: "Kitchen", ar: "المطبخ" },
  laundry: { fr: "Linge", en: "Laundry", ar: "الغسيل" },
  home: { fr: "Maison & Hygiène", en: "Home & Hygiene", ar: "المنزل والنظافة" },
  "personal-care": { fr: "Soins Corps & Cheveux", en: "Body & Hair Care", ar: "العناية بالجسم والشعر" }
};
